export interface IEnvironment {
	production: boolean
	environment: EEnvironment
	operationGatewayMexico: string
	gateway: string
	signinRedirectUrl: string
	signoutRedirectUrl: string
}

export enum EEnvironment {
	prod = 'prod',
	test = 'test',
	dev = 'dev',
	local = 'local',
}
